import { Component, Input } from '@angular/core';
import { IAssignment } from 'src/app/assignment/models/assignment';
import { dueDateClass } from 'src/app/shared/helpers/date-helpers';

@Component({
    selector: 'app-assignment-list',
    templateUrl: './assignment-list.component.html',
    styleUrl: './assignment-list.component.css',
    standalone: false
})
export class AssignmentListComponent {
  @Input() assigments: IAssignment[];

  dueDateClass = dueDateClass;
}
